// extracted by mini-css-extract-plugin
export default {"input":"fpa-z","button":"gpa-z","selected":"hpa-z","sephoraImage":"ipa-z","unavailable":"jpa-z","image":"kpa-z"};